import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import Login from "Containers/NewLogin";
import DataTableContainer from "Containers/DataTableContainer";
import EditContainer from "Containers/EditContainer";
import { PrivateRoute } from "Utils/private-route";
import "./GlobalStyles.css";
import { Toaster } from "react-hot-toast";
import environment from './environments/environment';
function App() {

    const favicon = document.querySelector("link[rel~='icon']");
    if (favicon && environment.favicon) {
      favicon.href = environment.favicon.replace(
        '%PUBLIC_URL%',
        process.env.PUBLIC_URL || ''
      );
    }

  return (
    <div>
      <Toaster position="top-right" reverseOrder={false} />
      <BrowserRouter>
        <Switch>
          <PrivateRoute
            path={"/home"}
            name={"home"}
            component={DataTableContainer}
          />
          <PrivateRoute
            path={"/details"}
            name={"details"}
            component={EditContainer}
          />
          <Route path={"/login"} name={"login"} component={Login} />
          <Redirect from="/" to="/login" />
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
